import AccountDetailsDrawer from './AccountDetailsDrawer';
import { MT5AccountUser } from '../../utils/types';

interface DemoAccountDetailsDrawerProps {
  isOpen: boolean;
  onClose: () => void;
  account: MT5AccountUser | null;
  loading?: boolean;
}

export default function DemoAccountDetailsDrawer({
  isOpen,
  onClose,
  account,
  loading = false,
}: DemoAccountDetailsDrawerProps) {
  return (
    <AccountDetailsDrawer
      isOpen={isOpen}
      onClose={onClose}
      account={account}
      loading={loading}
      title="Demo Account Details"
    />
  );
}
